import { render, staticRenderFns } from "./EvaluateInfo.vue?vue&type=template&id=0ccb9306&"
import script from "./EvaluateInfo.vue?vue&type=script&lang=ts&"
export * from "./EvaluateInfo.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports